// extracted by mini-css-extract-plugin
module.exports = {"formConatiner":"FormBackground_formConatiner__3Owi3"};